/**
 * Рисует ли обложка собственный <h1>.
 *
 * На странице должен быть ровно один h1. Обложка ставит его сама, но только
 * когда действительно показывает заголовок: в макетах «только логотип» и
 * «только картинка» текста нет, а при пустом cover.title нет и заголовка.
 *
 * Главная спрашивает об этом перед тем, как подставить свой h1 с названием
 * заведения. Условие живёт здесь, а не дублируется в двух компонентах: разъехаться
 * им — значит получить либо два h1, либо ни одного, и заметить это только в аудите.
 */
import type { AppearanceConfig, AppearanceSurfaceKey } from '@shared/config'

/** Макеты, которые вообще не выводят текстовый заголовок. */
const LAYOUTS_WITHOUT_HEADING = new Set(['none', 'logo', 'media', 'hero'])

export function coverRendersHeading(
  appearance: AppearanceConfig,
  surface: AppearanceSurfaceKey,
): boolean {
  // Обложка — настройка сайта: в нативной сборке её нет вовсе (см. SiteCover.vue).
  if (surface !== 'site') return false

  const cover = appearance?.cover
  if (!cover || LAYOUTS_WITHOUT_HEADING.has(cover.layout)) return false

  return Boolean(cover.title?.trim())
}
